import React, { Fragment, useCallback, useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FacetedSearchCompact from '../ComponentsBrafab/FacetedSearchCompact';
import { AccordionPanel, Accordion } from '../ComponentsBrafab/Accordion';
import { query, updateFilterOption } from '../ActionsBrafab/FacetedSearch.action';
import SubNav from '../Components/SubNavCompact';
import SortCriteriaCompact from '../Components/SortCriteriaCompact';
import FilterTag from '../ComponentsBrafab/FilterTags';
import { translate } from '../Services/translation';
import { PRODUCT_VIEW_CACHED } from '../constants';

const FacetedSearchCompactContainer = (props) => {
    const dispatch = useDispatch();
    const {
        subNavigation,
        sortCriteria,
        facetFilters: globalFacetFilters,
        navigationTheme,
        productsViewCachedId,
    } = useSelector((state) => state.facetedSearch);

    const [facetFilters, setFacetFilters] = useState(globalFacetFilters || []);
    const previousCachedId = useRef(productsViewCachedId);
    useEffect(() => {
        if (previousCachedId.current !== productsViewCachedId) {
            setFacetFilters(globalFacetFilters);
            previousCachedId.current = productsViewCachedId;
        }
    }, [globalFacetFilters, productsViewCachedId]);

    useEffect(() => {
        dispatch(query(window.location.search.substr(1) || '', false));
    }, [dispatch]);

    const onFacetChange = useCallback(
        (filter, option) => {
            setFacetFilters((prevFacetFilters) => {
                return updateFilterOption(prevFacetFilters, filter, option);
            });
        },
        [setFacetFilters]
    );

    const onSearchResultDataChange = (dom) => {
        if ([null, undefined].includes(dom)) {
            return;
        }
        const container = document.createElement('div');
        container.innerHTML = dom;
        const existingResult = document.querySelector('#search-result');
        const tempResult = container.querySelector('#search-result');
        const existingFilter = existingResult.querySelector('#facetedSearchCompact');
        const tempFilter = tempResult.querySelector('#facetedSearchCompact');
        const replace = (node, newNode) => node.parentNode.replaceChild(newNode, node);
        // move existingFilter from existingResult to tempResult
        replace(tempFilter, existingFilter);
        // replace existingResult with tempResult ( newResult )
        replace(existingResult, tempResult);
        // bootstrap react components if any exists in the search result
        window.__litium.bootstrapComponents();
    };

    useEffect(() => {
        const productViewCached = window.__litium.cache
            ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {}
            : {};
        if (!productViewCached.used) {
            productViewCached.used = true;
            const dom = productViewCached.productsView;
            dom && onSearchResultDataChange(dom);
        }
    });

    const empty = (array) => !(array && array.length);

    const subNavigations = !subNavigation ? null : [subNavigation];
    const sortCriterias = !sortCriteria || !sortCriteria.sortItems ? null : sortCriteria.sortItems;

    const hidden = [subNavigations, facetFilters, sortCriterias].every((arr) => empty(arr));

    return hidden ? null : (
        <Fragment>
            <FilterTag
                {...{
                    facetFilters: globalFacetFilters,
                    navigationTheme: navigationTheme || '',
                }}
            />
            <Accordion
                className={`compact-filter ${!props.showCompactForDesktop ? 'hide-for-large' : ''}`}
            >
                {!empty(subNavigations) && false && (
                    <AccordionPanel
                        header={translate('facet.header.categories')}
                        className={
                            navigationTheme === 'category' && !props.showCompactForDesktop
                                ? 'hide-for-large'
                                : ''
                        }
                    >
                        <SubNav {...{ subNavigation: subNavigations }} />
                    </AccordionPanel>
                )}
                {!empty(facetFilters) && (
                    <AccordionPanel
                        header={translate('facet.header.filter')}
                        className={
                            navigationTheme === 'category' && !props.showCompactForDesktop
                                ? 'hide-for-large'
                                : ''
                        }
                    >
                        <FacetedSearchCompact
                            {...{
                                facetFilters,
                                onFacetChange,
                            }}
                        />
                    </AccordionPanel>
                )}
                {!empty(sortCriterias) && (
                    <AccordionPanel header={translate('facet.header.sortCriteria')}>
                        <SortCriteriaCompact {...{ sortCriteria: sortCriterias }} />
                    </AccordionPanel>
                )}
            </Accordion>
            {navigationTheme === 'category' && (
                <div className="compact-filter category-theme hide row">
                    <div className="large-10 columns">
                        <FacetedSearchCompact {...facetState} />
                    </div>
                    {!empty(sortCriterias) && (
                        <div className="large-2 columns">
                            <SortCriteriaCompact {...{ sortCriteria: sortCriterias }} />
                        </div>
                    )}
                </div>
            )}
        </Fragment>
    );
};

export default FacetedSearchCompactContainer;
